:host {
  background-size: cover;
  background-position: center center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

:host::after{
  content: "";
  position: absolute;
  display: block;
  top: 0;
  width: 45vw;
  height: 100%;
  background-image: url(https://cradlepoint.com/wp-content/uploads/2020/04/video-play-icon-1.webp?tr=lo-true);
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
}
:host:hover{
  cursor: pointer;
}
